export default {
    'page': require('./form.page').default,
    'panel.project-list': require('./form.panel-project-list').default,
    'panel.services': require('./form.panel-services').default,
    'panel.newsletter': require('./form.panel-newsletter').default,
    'panel.text-image': require('./form.panel-text-image').default,
    'panel.phone': require('./form.panel-text-image').default,
    'panel.form': require('./form.panel-form').default,
    'panel.text-content': require('./form.panel-text-content').default,
    'panel.values': require('./form.panel-values').default,
    'panel.full-image': require('./form.panel-full-image').default,

    'news_post': require('./form.news_post').default,
    'page_tab': require('./form.page_tab').default,
    'user': require('./form.user').default,
    'role': require('./form.role').default,
    'redirect_url': require('./form.redirect_url.js').default,
    'setting': require('./form.setting').default,

    'case_study': require('./form.case_study').default,
    'category': require('./form.category').default,
    'staff_member': require('./form.staff_member').default,
    'service': require('./form.service').default,

    'panel': require('./form.panel').default,
    // 'panel.testimonial': require('./form.panel-testimonial').default,
    // 'panel.location': require('./form.panel-location').default,
    // 'panel.tab-panel': require('./form.panel-tab-panel').default,
    // 'panel.text-content-2-column': require('./form.panel-text-content-2-column').default,

    // 'panel.banner': require('./form.panel-banner').default,
    // 'panel.slideshow': require('./form.panel-slideshow').default,

    'panel_item': require('./form.panel_item').default,
    // 'panel_form_field': require('./form.panel-form-panel_form_field').default,

    'campaign': require('./form.campaign').default,

    'contact': require('./form.contact').default,

    'news_category': require('./form.news_category.js').default,

    'layout': require('./form.layout.js').default,
}


// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.js